import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {DndProvider} from 'react-dnd-multi-backend';
import {HTML5toTouch} from 'rdndmb-html5-to-touch';
// import {getPlayerPoints} from 'helpers/game-helper';
import Logos from 'components/ui/logos/logos';
// import InfoBar from 'components/ui/info-bar/info-bar';
import Countdown from 'components/ui/countdown/countdown';
import Assignment from 'components/assignment/assignment';
import PopupAssignment from 'components/ui/popup-assignment/popup-assignment';
import PopupCaseFile from 'components/ui/popup-case-file/popup-case-file';
import './game.scss';

const Game = (props) => {	
	const {
		startTime, 
		durationMinutes, 
		scenarioId, 
		playerData, 
		taskIds, 
		handleFinishGame, 
		updatePlayerData, 
		updateBackground
	} = props;


	const [taskIndex, setTaskIndex] = useState(0);
	const [popupData, setPopupData] = useState(null);	
	const [popupFileData, setPopupFileData] = useState(null);
	
	// const playerPoints = getPlayerPoints(playerData);


	/**
	 * Go to next task
	 */
	const goToNextTask = () => {
		if (taskIds.length > taskIndex + 1) {
			setTaskIndex(taskIndex + 1);
		} else {
			handleFinishGame('manual');
		}
	};

	useEffect(() => {
		// Set background image id
		updateBackground('game', scenarioId);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	

	if (taskIds.length === 0) {
		return null;
	}

	return (
		<div className="Game">
			<Logos />
			<div className="Game-info">
				{/* <InfoBar points={playerPoints} iconId='trophy' scenarioId={scenarioId}/> */}
				<Countdown 
					startTime={startTime}
					minutes={durationMinutes}
				/>
			</div>

			<div className="Game-assignment">
				<DndProvider options={HTML5toTouch}>
					<Assignment 
						scenarioId={scenarioId}
						taskNumber={(taskIndex + 1)}
						totalTasks={taskIds.length}
						taskId={taskIds[taskIndex]}
						playerData={playerData}
						updatePlayerData={updatePlayerData}
						goToNextTask={goToNextTask}
						setPopupFileData={setPopupFileData}
						setPopupData={setPopupData}
					/>
				</DndProvider>
			</div>

			{popupData &&
				<PopupAssignment 
					scenarioId={scenarioId}
					title={popupData.title}
					text={popupData.text}
					closePopup={() => {setPopupData(null);}}
				/>
			}

			{popupFileData && <PopupCaseFile 
				popupData={popupFileData}
				setPopupData={setPopupFileData}
			/>}
		</div>
	);
};

Game.propTypes = {
	startTime: PropTypes.number,
	durationMinutes: PropTypes.number.isRequired,
	scenarioId: PropTypes.string.isRequired,
	playerData: PropTypes.object.isRequired,
	taskIds: PropTypes.array.isRequired,
	handleFinishGame: PropTypes.func.isRequired,
	updatePlayerData: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired,
};

export default Game;